import { useContext } from 'react';
import { MultiStepFormContext } from '@kanda-libs/ks-component-ts';
import { CLASS_NAMES } from './constants';
import StepItem from '../StepItem';

interface MultiStepFormStepSidebarProps {
  children: JSX.Element;
}

const MultiStepFormStepSidebar = ({
  children,
}: MultiStepFormStepSidebarProps) => {
  const { steps } = useContext(MultiStepFormContext);

  return (
    <div className={CLASS_NAMES.container}>
      <div className={CLASS_NAMES.sidebarContainer}>
        <div className={CLASS_NAMES.sidebarInnerContainer}>
          {steps.map((label, index) => (
            <StepItem
              key={label}
              index={index}
              label={label as unknown as number}
            />
          ))}
        </div>
      </div>
      <div className={CLASS_NAMES.contentContainer}>
        <div className={CLASS_NAMES.contentInnerContainer}>
          <div className={CLASS_NAMES.content}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default MultiStepFormStepSidebar;
